import { Section, Text } from "@react-email/components";
import { EmailHeading } from "@/email/components/EmailHeading";
import { EmailLink } from "@/email/components/EmailLink";
import { EmailText } from "@/email/components/EmailText";
import { EmailWrapper } from "@/email/components/EmailWrapper";
import { isOurTenant } from "@/store/tenant/selectors";
import { ITenant } from "@/types/tenant";
import { themeColourToCssRgb } from "@/utils/string";

interface VerifyEmailProps {
    code?: string;
    tenant: ITenant | null;
}

const VerifyEmail = ({ code = "1234", tenant }: VerifyEmailProps) => {
    const is1TemplateTenant = isOurTenant(tenant);
    const preview = is1TemplateTenant ? "1Template" : "Your";
    const heading = is1TemplateTenant
        ? "1Template verification code"
        : "Verification code";
    const contactEmail = tenant?.contactEmail || "hello@1template.io";
    const primaryColor = themeColourToCssRgb(
        tenant?.theme?.primary?.["primary-700"],
        "#3D61CC",
    );

    const codeText = {
        fontSize: "36px",
        fontWeight: "700",
        color: primaryColor,
        margin: "24px 0",
        lineHeight: 1.2,
    };

    return (
        <EmailWrapper
            preview={`${preview} Email Verification: ${code}`}
            tenant={tenant}
        >
            <Section>
                <EmailHeading>{heading}</EmailHeading>
                <EmailText>
                    We want to make sure it&apos;s really you. Please enter the
                    following verification code when prompted.
                </EmailText>
                <Text style={codeText}>{code}</Text>
                <EmailText>This code is valid for 15 minutes</EmailText>
                <EmailText>
                    If you didn&apos;t request this verification, please ignore
                    this email or contact us at{" "}
                    <EmailLink href={`mailto:${contactEmail}`}>
                        {contactEmail}
                    </EmailLink>
                    .
                </EmailText>
            </Section>
        </EmailWrapper>
    );
};

export default VerifyEmail;
